const japanese = {
    search_title: '探す',
    search_everything: '奈良周辺のすべてを探す',
    search_accommodation: '奈良周辺の宿泊施設を探す',
    search_activity: '奈良周辺のアクティビティを探す',
    search_product: '奈良周辺の商品を探す',
    search_restaurant: '奈良周辺のレストランを探す',
    search_subtitle: `奈良周辺のアクティビティを探す`,
    search_subsubtitle: `「候補リストに追加」をクリックし、候補リストから予約にお進みください。`,
    search_button: `探す`,
    search_price_range: '価格帯',
    search_all_categories: 'すべてのカテゴリ',
    accommodation: '宿泊施設',
    activity: 'アクティビティ',
    restaurant: '飲食店',
    produce: '買い物',
    search_keyword: 'キーワード',
    wishlist_empty: 'カートが空です',
    close: '閉じる',
    check_availability: '予約・決済に進む',
    load_more: 'もっと読み込む',
    loading: ' 読み込み中 ...',
    view_details: '詳細を見る',
    basic_info: '基本情報',
    map: '地図',
    home: 'ホーム',
    list: 'リスト',
    details: '詳細',
    name: '名前',
    address: '住所',
    phone: '電話',
    fax: 'ファックス',
    email: 'メール',
    website: 'ウェブサイト',
    from: 'から',
    price: '価格（税込）',
    rate: '料金',
    under_maintenance: `現在商品を登録中です。またのご利用をお待ちしております。
    <span class='emoji'>&#128521</span>`,
    add_to_wishlist: '予約',
    add_to_wishlist_shp: '購入',
    remove_from_wishlist: '本を削除する',
    wishlist: 'カート',
    not_available: '満席',
    not_available_shp: '在庫切れ',
    night: '夜',
    guest: 'ゲスト',
    item: 'アイテム',
    date: '年/月/日',
    read_more: '続きを読む',
    check_price_availability_res: '価格と在庫状況を確認する',
    check_price_availability_acc: '空室状況を確認',
    check_price_availability_act: '予約状況を確認',
    check_price_availability_shp: '在庫状況を確認',
    available_products: '利用可能な製品',
    available_products_act: '予約状況',
    available_products_shp: '在庫状況',
    start_time: '始まる時間',
    different_time: 'または別の時間を選択してください',
    dairy: '乳製品',
    sweet: '甘い',
    wine: 'ワイン',
    quantity: '数量',
    request_to_book: 'リクエスト予約',
    sort_by: '並べ替え条件',
    name_az: '名前昇順',
    name_za: '名前降順',
    price_az: '価格の安い順',
    price_za: '価格の高い順',
    extras: 'エクストラ',
    no_public_website: '公開ウェブサイトはありません',
    no_public_email: '公開メールはありません',
    firstName: 'ファーストネーム',
    lastName: '苗字',
    userEmail: 'Eメール',
    conf_email: 'メールを再入力',
    mobile: '携帯電話/携帯電話',
    city: '郊外/都市',
    state: '州/国',
    zipcode: '郵便番号/郵便番号',
    country: '国',
    marketing: 'マーケティング',
    business: '仕事',
    specialRequest: '特記事項',
    is_required: ' 必要とされている',
    is_not_the_same: ' 同じではない',
    is_not_a_valid_email: ' 有効じゃない',
    must_be_a_number: ' 数字でなければなりません',
    select_country: '国を選択',
    submit: '送信',
    customer_detail: '顧客の詳細',
    booking_information: '予約情報',
    product: '製品',
    options_costs: 'オプション/コスト',
    totals: '合計',
    adult: '大人',
    check_in: 'チェックイン',
    check_out: 'チェックアウト',
    back_to_nara: 'Back To Nara',
    booking_req_detail_wait: '予約リクエストの詳細-確認待ち',
    booking_req_instructions: '24時間以内に、予約リクエストがオペレーターによって受け入れられたかどうかを確認するメールが届きます。 予約リクエストが受理されるまで、支払いは行われません。',
    request_date: 'リクエスト日（UTC）',
    booking_reference: '予約番号',
    booked_by: 'によって予約された',
    supplier_information: 'サプライヤー情報',
    total_gst: '合計（GSTを含む）',
    amount_paid: '支払額（GSTを含む）',
    amount_owing: '未払い額（GSTを含む）',
    quick_booking: '即時予約',
    guest_warning: '最小ゲストは1人です'
};
export default japanese;
